/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import Box from "components/generals/Box";
import InsuranceTable from "components/tables/InsuranceTable";
import { CoreAPI_URLs } from "constants/http.const";
import useHttp from "hooks/http.hook";
import { InsuranceInterface, QueryResultInterface } from "medicalsystem-shared";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

/**
 * Content component for displaying and managing insurance plans.
 * Provides a table view of all insurance plans with search and pagination functionality.
 * @returns {React.ReactElement} The insurance data content component
 */
const InsuranceDataContent: FC = () => {
  const [isLoading, _error, sendRequest] = useHttp();
  const [insuranceList, setInsuranceList] = useState<InsuranceInterface[]>([]);
  const [page, setPage] = useState<number>(1);
  const [pageTotal, setPageTotal] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowsTotal, setRowsTotal] = useState<number>(0);
  const [filterModel, setFilterModel] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    console.log("sending request...");
    const nameParam = filterModel ? `name=${filterModel}&` : "";
    const url = `${CoreAPI_URLs.INSURANCE_GET_ALL}?${nameParam}page=${page}&pageSize=${pageSize}`;

    sendRequest(url, onGetInsuranceHandler, "GET");
  }, [page, pageSize, filterModel]);

  const onGetInsuranceHandler = (insurancesResponse: QueryResultInterface<InsuranceInterface>) => {
    setInsuranceList(insurancesResponse.results);
    setRowsTotal(insurancesResponse.total);
    setPageTotal(Math.ceil(insurancesResponse.total / pageSize));
  };

  return (
    <Box>
      <InsuranceTable
        modelList={insuranceList}
        setModelList={setInsuranceList}
        canSearchPlaceholder={t("insuranceForm.searchInsurance")}
        entriesPerPage={{ defaultValue: pageSize }}
        setPageState={setPage}
        setPageSizeState={setPageSize}
        apiPagination={true}
        apiPageTotal={pageTotal}
        apiRowsTotal={rowsTotal}
        apiPageCurrentIndex={page}
        setModelFilter={setFilterModel}
        isLoading={isLoading}
      />
    </Box>
  );
};

export default InsuranceDataContent;
